module.exports = __webpack_public_path__ + "img/arrow-t.630776a4.svg";